import * as React from 'react';

export function Unlocked({ fill = '#000', width = 25, height = 25, className, id, onClick }: any) {
    return (
        <svg width="16" height="20" viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.619 0c2.667 0 4.762 2.095 4.762 4.762v1.905h.952a1.91 1.91 0 0 1 1.905 1.904v9.524A1.91 1.91 0 0 1 13.333 20H1.905A1.91 1.91 0 0 1 0 18.095V8.571a1.91 1.91 0 0 1 1.905-1.904h8.666V4.762A2.967 2.967 0 0 0 7.62 1.81a2.967 2.967 0 0 0-2.952 2.952h-1.81C2.857 2.095 4.952 0 7.62 0zm0 11.429a1.91 1.91 0 0 0-1.905 1.904 1.91 1.91 0 0 0 1.905 1.905 1.91 1.91 0 0 0 1.905-1.905 1.91 1.91 0 0 0-1.905-1.904z" fill="#757575" fill-rule="nonzero" />
        </svg>
    );
}
